import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import moment from 'moment';
import { notification } from 'antd';

export default class OrderReturnStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };

  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    strDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    orStat: '',
    orGdNm: '',
    orUserId: '',
    orUserNm: '',
    ceCd: '',
    ceBranchCd: '',
    orCartNo: '',

    pageIdx: 1,
    recordCountPerPage: 10,
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };
  //----------------------------------
  /* 상세데이터 */
  @observable
  _detailData = [];

  @computed
  get detailData() {
    return this._detailData;
  }

  @action
  onDetailData = (data) => {
    this._detailData = data;
  };
  
  //----------------------------------
  @observable 
  _returnList = [];

  @computed
  get returnList() {
    return this._returnList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }
  //----------------------------------
  @action
  onClear = () => {
    this._returnList = [];
    this._pageInfo = null;
    this._detailData = [];

    this._valCondition = {
      ...this._valCondition,
      strDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      orStat: '',
      orGdNm: '',
      orUserId: '',
      orUserNm: '',
      ceCd: '',
      ceBranchCd: '',
      orCartNo: '',

      pageIdx: 1,
      recordCountPerPage: 10,
    };
  };
  //-----------------------------------
  //  반품 리스트
  //-----------------------------------
  @action
  disReturnList = async (pageIdx, recordCountPerPage) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }

    let addition = new Addition();

    addition.setCmdName('DIS-RETURN-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'strDate', paraValue: this._valCondition.strDate});
    reqInputMsg.addParam({paraName: 'endDate', paraValue: this._valCondition.endDate});
    reqInputMsg.addParam({paraName: 'orStat', paraValue: this._valCondition.orStat});
    reqInputMsg.addParam({paraName: 'orGdNm', paraValue: this._valCondition.orGdNm});
    reqInputMsg.addParam({paraName: 'orUserId', paraValue: this._valCondition.orUserId});
    reqInputMsg.addParam({paraName: 'orUserNm', paraValue: this._valCondition.orUserNm});
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: this._valCondition.ceCd});
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: this._valCondition.ceBranchCd});
    reqInputMsg.addParam({paraName: 'orCartNo', paraValue: this._valCondition.orCartNo});
    
    return await callCmd(reqInputMsg, 'orderReturn')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._returnList = res.result;
          this._pageInfo = res.addition;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._returnList = [];
          this._pageInfo = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._returnList = [];
        this._pageInfo = null;
        console.log('error', error);
      });
  };

  //-----------------------------------
  //  반품 승인
  //-----------------------------------
  @action
  appReturnInfo = async (data) => {
    let addition = new Addition();
    addition.setCmdName('APP-RETURN-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'orNo', paraValue: data.orNo.toString()});
    reqInputMsg.addParam({paraName: 'orCartNo', paraValue: data.orCartNo.toString()});

    
    return await callCmd(reqInputMsg, 'orderReturn')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`반품승인이 성공하였습니다.`, duration: 2});
            this.disReturnList();
          } else {
            notification.success({placement: 'bottomLeft', message:`반품승인이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`반품승인이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`반품승인이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  //-----------------------------------
  //  반품반려
  //-----------------------------------
  @action
  rejectReturnInfo = async (data) => {
    let addition = new Addition();
    addition.setCmdName('REJECT-RETURN-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'orNo', paraValue: data.orNo.toString()});
    reqInputMsg.addParam({paraName: 'rejectReason', paraValue: data.rejectReason});
    
    return await callCmd(reqInputMsg, 'orderReturn')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`반품반려에 성공하였습니다.`, duration: 2});
            this.disReturnList();
          } else {
            notification.success({placement: 'bottomLeft', message:`반품반려에 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`반품반려에 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`반품반려에 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };
}
  
